import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import styles from "./SavedPrice.module.scss";
import { priceDifferenceInPercentage } from "../../../../util/helper/priceDifferenceInPercentage";
import { priceDifference } from "../../../../util/helper/priceDifference";
import { savedAmount } from "../../../../util/helper/savedAmount";

function SavedPrice(props: any) {
  const {
    product, wasPrice = product.wasPrice, price = product.price, className = "",
    shortForm = false,
  } = props;
  const router = useRouter();
  const { locale } = router;
  const { t } = useTranslation("common");

  if (wasPrice <= price) {
    return null;
  }

  const component = !shortForm ? (
    <div>
      {`${t("You save") } `}

      <b>
        {t("saved_amount", { saved_price: savedAmount(wasPrice, price) })}
      </b>

      <span className="m-l-5">
        {`(${priceDifferenceInPercentage(wasPrice, price).toFixed(0)}% ${t("Off")})`}
      </span>
    </div>
  ) : (
    <span className="m-l-5">
      {`(${priceDifference(wasPrice, price, locale)} ${t("Off")})`}
    </span>
  );

  return (
    <div className={`d-flex align-items-center ${className} ${styles.container}`}>
      {component}
    </div>
  );
}

export default SavedPrice;
